module.exports = __webpack_public_path__ + "static/img/jumpwr.f1addf17.webp";